import { Card } from "components/atoms/Card";
import { Empty } from "components/atoms/Empty";
import { Tip } from "components/atoms/Tip";
import { SocialScrapingContent } from "types/scraping/socialScraping.type";
import { SocialListItem } from "../SocialListItem";

interface SocialListProps {
  data: SocialScrapingContent[];
  isLoading: boolean;
  isEmptyKeyword?: boolean;
  filetrsApplyed?: any;
  isScraping: boolean;
  externalRef: any;
}
export const SocialList = ({
  data,
  isLoading,
  isEmptyKeyword,
  isScraping,
  filetrsApplyed,
  externalRef,
}: SocialListProps) => {
  //TODO poderia criar um component genérico para tratar mensagens de empty
  if (!data.length && !isLoading && isEmptyKeyword) {
    return (
      <Card className="col-span-10 bg-transparent border-0 min-h-auto md:min-h-[74vh] justify-center items-center ">
        <Empty
          type="no-messages"
          message="No Keywords added yet"
          title="No keywords found"
          className="!gap-1 mb-8"
        />
        <div className="h-full w-full flex flex-col sm:gap-2 justify-start items-center text-gray-400 text-base">
          <Tip
            icon="url"
            title="Start by adding a keyword"
            description="You haven't added any keywords yet. Start by entering your first one above."
          />
          <Tip
            icon="clock"
            title="Fetching your first data"
            description="Once you've added your first keyword, we'll fetch data from social intent. This may take a minute — hang tight!"
          />
          <Tip
            icon="filter"
            title="Customize your source"
            description="With keywords, you can filter your data by source, helping you retrieve the most relevant information for your needs."
          />
        </div>
      </Card>
    );
  }

  if (
    !data.length &&
    !isLoading &&
    !isScraping &&
    filetrsApplyed &&
    filetrsApplyed.keywords?.length > 0
  ) {
    return (
      <Card className="col-span-10 bg-transparent border-0 min-h-auto md:min-h-[74vh] justify-center items-center ">
        <Empty
          message="No results for your keywords in the last 24 hours"
          className="!gap-1 mb-8"
        />
      </Card>
    );
  }
  if (!data.length && !isLoading && !isScraping) {
    return (
      <Card className="col-span-10 bg-transparent border-0 min-h-auto md:min-h-[74vh] justify-center items-center ">
        <Empty
          message="If you have active filters, consider removing them to see more results."
          className="!gap-1 mb-8"
        />
      </Card>
    );
  }
  if (!data.length && !isLoading && isScraping) {
    return (
      <Card className="col-span-10 bg-transparent border-0 min-h-auto md:min-h-[74vh] justify-center items-center jusce">
        <Empty
          title="Processing Social Intent Data"
          message="We are currently collecting information based on your keyword. Please wait a moment."
          type="no-mentions"
        />
      </Card>
    );
  }
  return (
    <div
      ref={externalRef}
      className="col-span-12 rounded-b-none p-8 row-span-10 row-start-2 flex flex-col  w-full h-full max-w-full overflow-y-auto "
    >
      {isLoading ? (
        <SocialListItem isLoading />
      ) : (
        data?.map((item) => <SocialListItem {...item} key={item.id} />)
      )}
    </div>
  );
};
